'use client';
import Button from'../components/ui/Button';
import Image from'next/image';
import Link from 'next/link';
import { useTranslations } from '../utils/translations';

export default function NewFeatureSection() {
  const { t } = useTranslations();
  
  const handleNewFeature = () => {
    // Navigation logic for new question feature
  }

  return (
    <section className="w-full bg-[var(--bg-main)] py-6 sm:py-8 md:py-10 lg:py-[40px] mt-4 sm:mt-6 md:mt-8 lg:mt-[30px]">
      <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Column */}
        <div className="flex flex-col justify-start items-center w-full gap-8 sm:gap-10 md:gap-12 lg:gap-[62px]">
          
          {/* Feature Introduction */}
          <div className="flex flex-col justify-start items-center w-full gap-6 sm:gap-8 md:gap-10 lg:gap-[50px]">
            
            {/* Feature Description */}
            <p className="text-center text-[var(--text-accent)] font-inter text-[16px] sm:text-[18px] md:text-[21px] lg:text-[24px] leading-[24px] sm:leading-[24px] md:leading-[30px] lg:leading-[34px] w-full max-w-6xl px-4 sm:px-6 break-words overflow-wrap-anywhere text-[rgba(247,255,192,0.902)] font-medium">
              {t('home.new_feature.description')}
            </p>
            
            {/* Reading Question Button */}
            <Link href="/card-question" className="inline-block">
              <Button
                className="bg-[#F8FFBE] text-black font-inter font-bold text-[16px] sm:text-[16px] md:text-[18px] leading-[18px] sm:leading-[20px] md:leading-[22px] text-center justify-center rounded-full shadow-lg px-6 py-3 pl-2 gap-2 hover:bg-opacity-90 transition-all duration-200 w-auto flex flex-col sm:flex-row items-center justify-center"
              >
                <div className="flex items-center gap-3 flex-wrap justify-center">
                  <span className="bg-red-600 text-[#ffffff] px-3 sm:px-4 py-1 rounded-full text-[13px] sm:text-[14px] md:text-[16px] flex-shrink-0">{t('home.new_feature.new_badge')}</span>
                  <span className="break-words">{t('home.new_feature.button_text')}</span>
                  <Image
                    src="/images/img_vector_black_900.svg"
                    alt={t('home.new_feature.accessibility.arrow_alt')}
                    width={22}
                    height={14}
                    className="w-[18px] h-[12px] sm:w-[20px] sm:h-[13px] md:w-[22px] md:h-[14px] flex-shrink-0"
                  />
                </div>
              </Button>
            </Link>
          </div>
          
        </div>
      </div>
    </section>
  )
}